// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:27
import { UndoDeleteCardComponentArgs_abstract } from './../../abstract/SagaBase/Defines/UndoDeleteCardComponentArgs_abstract';
export class UndoDeleteCardComponentArgs extends UndoDeleteCardComponentArgs_abstract {}
